import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "@/context/AuthContext";
import { Hammer, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } catch (err) {
      const msg = err.response?.data?.detail;
      toast.error(typeof msg === "string" ? msg : "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white flex flex-col" data-testid="admin-login-page">
      <Helmet>
        <title>Admin · Prime Build Design LTD</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <header className="border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="admin-login-logo">
            <div className="w-10 h-10 bg-white text-slate-900 flex items-center justify-center">
              <Hammer size={20} strokeWidth={1.5} />
            </div>
            <div>
              <div className="font-display font-bold text-lg">Prime Build Design</div>
              <div className="text-[10px] tracking-[0.25em] uppercase text-slate-400">Admin Portal</div>
            </div>
          </Link>
          <Link to="/" className="text-sm text-slate-400 hover:text-white" data-testid="admin-login-back">← Back to site</Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4">
        <form onSubmit={submit} className="w-full max-w-md bg-slate-900 border border-slate-800 p-8 md:p-10" data-testid="admin-login-form">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 bg-[#C5A059] text-white flex items-center justify-center"><Lock size={18} /></div>
            <div>
              <div className="overline text-[#C5A059]">Restricted area</div>
              <h1 className="font-display text-2xl font-bold mt-1">Admin Sign in</h1>
            </div>
          </div>

          <div className="space-y-5">
            <div>
              <label className="overline">Email</label>
              <input data-testid="admin-email" required type="email" className="field mt-2 bg-slate-950 text-white border-slate-700" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label className="overline">Password</label>
              <input data-testid="admin-password" required type="password" className="field mt-2 bg-slate-950 text-white border-slate-700" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <button type="submit" disabled={loading} className="btn-accent w-full justify-center" data-testid="admin-login-submit">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </div>
        </form>
      </main>
    </div>
  );
}
